import { Autocomplete, TextField } from "@mui/material";
import { CitySelectorProps } from "../types/CitySelectorProps";

const CitySelector: React.FC<CitySelectorProps> = ({
  cityList,
  onCityChange,
}) => {
  return (
    <Autocomplete
      options={cityList}
      getOptionLabel={(option: any) => option.name}
      onChange={(event, selectedCity) => onCityChange(selectedCity)}
      size="small"
      renderInput={(params) => (
        <TextField {...params} label="City" variant="outlined" fullWidth />
      )}
    />
  );
};

export default CitySelector;
